<template lang="pug">
canvas.MiniMap(:style="{ height: size.height + 'px', width: size.width + 'px' }" :width="size.width * 2" :height="size.height * 2")
</template>

<script>
import { mouse, range, lerp } from '@/js/utils'

export default {
  name: 'MiniMap',
  props: ['displayMouse'],
  data () {
    return {
      size: {
        width: 100 * window.innerWidth / window.innerHeight,
        height: 100
      },
      ctx: {},
      cursorPos: mouse
    }
  },
  methods: {
    draw () {
      this.ctx.clearRect(0, 0, this.$el.width, this.$el.height)
      this.ctx.strokeStyle = this.$store.state.forceLightMinimap ? this.$store.state.colors.light : this.$store.state.hoveredCard ? this.$store.state.colors.light : this.$store.state.colors.dark
      this.ctx.fillStyle = this.$store.state.forceLightMinimap ? this.$store.state.colors.light : this.$store.state.hoveredCard ? this.$store.state.colors.light : this.$store.state.colors.dark
      this.ctx.lineWidth = 2

      for (const card of this.$store.state.cards) {
        this.ctx.beginPath()
        this.ctx.rect(
          card.mesh.position.x * 2 + this.size.width - card.size.width,
          card.mesh.position.y * -2 + this.size.height - card.size.height,
          card.size.width * 2,
          card.size.height * 2
        )
        if (card.hasBeenVisited) {
          this.ctx.fill()
        } else this.ctx.stroke()
      }

      if (this.displayMouse) {
        // cursor
        this.cursorPos = {
          x: lerp(this.cursorPos.x, mouse.x, 0.08),
          y: lerp(this.cursorPos.y, mouse.y, 0.08)
        }

        this.ctx.beginPath()
        this.ctx.moveTo(
          range(this.cursorPos.x, 0, window.innerWidth, 0, this.$el.width),
          range(this.cursorPos.y, 0, window.innerHeight, 0, this.$el.height) - 5
        )

        this.ctx.lineTo(
          range(this.cursorPos.x, 0, window.innerWidth, 0, this.$el.width),
          range(this.cursorPos.y, 0, window.innerHeight, 0, this.$el.height) + 5
        )

        this.ctx.moveTo(
          range(this.cursorPos.x, 0, window.innerWidth, 0, this.$el.width) - 5,
          range(this.cursorPos.y, 0, window.innerHeight, 0, this.$el.height)
        )

        this.ctx.lineTo(
          range(this.cursorPos.x, 0, window.innerWidth, 0, this.$el.width) + 5,
          range(this.cursorPos.y, 0, window.innerHeight, 0, this.$el.height)
        )
        this.ctx.stroke()
      }

      // // outer box
      // this.ctx.rect(1, 1, this.size.width * 2 - 2, this.size.height * 2 - 2)
      // this.ctx.stroke()

      requestAnimationFrame(this.draw.bind(this))
    }
  },
  mounted () {
    window.addEventListener('resize', () => { this.size.width = 100 * window.innerWidth / window.innerHeight })
    this.ctx = this.$el.getContext('2d')
    requestAnimationFrame(this.draw.bind(this))
  }
}
</script>

<style lang="scss" scoped>
.MiniMap {
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 40;
}
</style>
